<template>
  <v-expand-transition>
    <div
      :id="sectionElId(section)"
      style="margin-top:20px;"
      v-if="showEsignature"
    >
      <v-card>
        <v-card-text>
          <div
            v-html="section.text"
          />
        </v-card-text>
        <v-toolbar
          dense
          flat
          style="position:relative;"
        >
          <v-icon>
            mdi-signature
          </v-icon>
          &nbsp;&nbsp;
          <b>You will be requested to electronically sign this document after submission and review.</b>
        </v-toolbar>
      </v-card>
    </div>
  </v-expand-transition>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'UserFormESignature',
  props: ['userFormId', 'section'],
  data () {
    return {
      infoDialog: false
    }
  },
  computed: {
    ...mapGetters('userform', [
      'answer'
    ]),
    showEsignature(){
      if(!this.section.conditional_question_id) return true
      var answer =  this.answer(this.section.conditional_question_id, this.section.conditional_fieldtype_id)
      if(answer && answer.string == this.section.conditional_value) return true
      return false
    }
  },
  methods: {
    sectionElId (section) {
      return `section-${section.id}`
    }
  }
}
</script>

<style scoped>
  div >>> p {
    margin: 0 !important;
  }
</style>
